/**
 * Get the default environment from a list of environments
 * Returns the primary environment if available, otherwise the first environment
 * 
 * @param {Array} environments - Array of environment objects
 * @returns {Object|null} - The default environment object or null if no environments exist
 */
export function getDefaultEnvironment(environments) {
  if (!environments || !Array.isArray(environments) || environments.length === 0) {
    return null;
  }
  
  // Try to find primary environment first
  const primaryEnv = environments.find(e => e.is_primary === 1);
  if (primaryEnv) {
    return primaryEnv;
  }
  
  // Fallback to first environment
  return environments[0] || null;
}
